import { takeLatest, put, all, call } from 'redux-saga/effects';

import MemberActionTypes from './member.types';
import {
	memberDetailsAdd,
	memberDetailsUpdate,
	memberListGet,
	memberDetailsFetch,
	memberDetailsDelete,
	coApplicantHighMarkDetailsFetch,
	verifyDocumentDetailsFetch,
	checkHighmarkDetailsFetch,
	checkEquifaxDetailsFetch,
	checkCoApplicantHighmarkDetailsFetch,
	updateNoLoanMember,
	checkTopupLoanMember,
	updateMemberIsApproveService,
	PaySprintLogDetailsFetch,
	MemberAuditDetailsFetch,
	MemberVerifyDetailsFetch,
	MemberVerifyDetailsUpdate,
	MemberKYCDetailsUpdate,
	MemberTransferDetailsUpdate,
	memberOtherDetailsAdd,
	memberBusinessDetailsAdd,
} from './member.service';

import {
	addMemberDetailsSuccess,
	addMemberDetailsFailure,
	addMemberDetailsResponseChanged,
	updateMemberDetailsSuccess,
	updateMemberDetailsFailure,
	updateMemberDetailsResponseChanged,
	getMemberDetailsSuccess,
	getMemberDetailsFailure,
	getMemberDetailsResponseChanged,
	fetchMemberDetailsSuccess,
	fetchMemberDetailsFailure,
	fetchMemberDetailsResponseChanged,
	deleteMemberDetailsSuccess,
	deleteMemberDetailsFailure,
	deleteMemberDetailsResponseChanged,
	fetchCoApplicantHighMarkDetailsSuccess,
	fetchCoApplicantHighMarkDetailsFailure,
	fetchCoApplicantHighMarkDetailsResponseChanged,
	verifyDocumentDetailsSuccess,
	verifyDocumentDetailsFailure,
	verifyDocumentDetailsResponseChanged,
	checkHighmarkDetailsSuccess,
	checkHighmarkDetailsFailure,
	checkHighmarkDetailsResponseChanged,
	checkEquifaxDetailsSuccess,
	checkEquifaxDetailsFailure,
	checkEquifaxDetailsResponseChanged,
	checkCoApplicantHighmarkDetailsSuccess,
	checkCoApplicantHighmarkDetailsFailure,
	checkCoApplicantHighmarkDetailsResponseChanged,
	updateNoLoanMemberFailure,
	updateNoLoanMemberSuccess,
	updateNoLoanMemberResponseChanged,
	checkTopupLoanMemberFailure,
	checkTopupLoanMemberSuccess,
	checkTopupLoanMemberResponseChanged,
	updateMemberRejectFailure,
	updateMemberRejectSuccess,
	updateMemberRejectResponseChanged,
	updateMemberRecheckFailure,
	updateMemberRecheckSuccess,
	updateMemberRecheckResponseChanged,
	updateMemberApproveFailure,
	updateMemberApproveSuccess,
	updateMemberApproveResponseChanged,
	fetchPaySprintLogDetailsSuccess,
	fetchPaySprintLogDetailsFailure,
	fetchPaySprintLogDetailsResponseChanged,
	fetchMemberAuditDetailsSuccess,
	fetchMemberAuditDetailsFailure,
	fetchMemberAuditDetailsResponseChanged,
	fetchMemberVerifyDetailsSuccess,
	fetchMemberVerifyDetailsFailure,
	fetchMemberVerifyDetailsResponseChanged,
	updateMemberVerifyDetailsSuccess,
	updateMemberVerifyDetailsFailure,
	updateMemberVerifyDetailsResponseChanged,
	updateMemberKYCDetailsSuccess,
	updateMemberKYCDetailsFailure,
	updateMemberKYCDetailsResponseChanged,
	updateMemberTransferDetailsSuccess,
	updateMemberTransferDetailsFailure,
	updateMemberTransferDetailsResponseChanged,
	addMemberOtherDetailsSuccess,
	addMemberOtherDetailsFailure,
	addMemberOtherDetailsResponseChanged,
	addMemberBusinessDetailsSuccess,
	addMemberBusinessDetailsFailure,
	addMemberBusinessDetailsResponseChanged,
} from './member.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START ADD MEMBER DETAILS  ******************** */
export function* addMemberDetails({ payload }: any) {
	try {
		const key = 'AddMemberPhoneNumber';
		const {
			memberPhoneNumber,
			userID,
			databaseName,
			companyID,
			fetchDetails,
			MemberID,
			sendOTP,
			from,
			accessType,
		} = payload;

		const jsonData = {
			MemberPhoneNumber: memberPhoneNumber,
			MemberCreatedBy: userID,
			DatabaseName: databaseName,
			MemberCompanyID: companyID,
			FetchDetails: fetchDetails,
			MemberID,
			SendOTP: sendOTP,
			AccessType: accessType,
			From: from,
			Secratekey: key,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addMemberDetailsFailure(responseData.data));
		} else {
			yield put(addMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addMemberDetailsFailure(error));
	}
}

export function* resetAddMemberResponse() {
	yield put(addMemberDetailsResponseChanged());
}

export function* onAddMemberDetails() {
	yield takeLatest(MemberActionTypes.ADD_MEMBER_DETAILS_START, addMemberDetails);
}

export function* onAddMemberDetailsResponseReset() {
	yield takeLatest(MemberActionTypes.ADD_MEMBER_DETAILS_RESPONSE_RESET, resetAddMemberResponse);
}
/** *********************  END ADD MEMBER DETAILS ******************** */

/** *********************  START UPDATE MEMBER DETAILS  ******************** */
export function* updateMemberDetails({ payload }: any) {
	try {
		const key = 'UpdateMemberDetailsKey';
		const {
			companyID,
			memberID,
			memberName,
			memberCity,
			memberState,
			memberCountry,
			memberDistrict,
			nextUniqueAreaID,
			memberAddress,
			memberStartDate,
			memberLocation,
			memberMapLatitude,
			memberMapLongitude,
			memberPincode,
			village,
			userID,
			userName,
			userAccessMemberID,
			infogCompanyID,
			databaseName,
			isHeadOffice,
			isNbfcLogin,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			MemberID: memberID,
			MemberName: memberName,
			MemberCity: memberCity,
			MemberState: memberState,
			MemberCountry: memberCountry,
			MemberDistrict: memberDistrict,
			NextUniqueAreaID: nextUniqueAreaID,
			MemberAddress: memberAddress,
			StartDate: memberStartDate,
			MemberLocation: memberLocation,
			MemberLatitude: memberMapLatitude,
			MemberLongitude: memberMapLongitude,
			MemberPinCode: memberPincode,
			Village: village,
			CreatedBy: userID,
			UserName: userName,
			UserAccessMemberID: userAccessMemberID,
			InfogCompanyID: infogCompanyID,
			DatabaseName: databaseName,
			IsHeadOffice: isHeadOffice ? 1 : 0,
			IsNbfcLogin: isNbfcLogin,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberDetailsFailure(responseData.data));
		} else {
			yield put(updateMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberDetailsFailure(error));
	}
}

export function* resetUpdateMemberDetailsResponse() {
	yield put(updateMemberDetailsResponseChanged());
}

export function* onUpdateMemberDetails() {
	yield takeLatest(MemberActionTypes.UPDATE_MEMBER_DETAILS_START, updateMemberDetails);
}

export function* onUpdateMemberResponseReset() {
	yield takeLatest(
		MemberActionTypes.UPDATE_MEMBER_DETAILS_RESPONSE_RESET,
		resetUpdateMemberDetailsResponse,
	);
}
/** *********************  END UPDATE MEMBER DETAILS ******************** */

/** *********************  START GET MEMBER LIST  ******************** */
export function* getMemberList({ payload }: any) {
	try {
		const key = 'GetMemberListKey';
		const {
			companyID,
			userID,
			userRole,
			userLevel,
			databaseName,
			userAccessMemberID,
			searchValueSet,
			phoneNumber,
			aadharNumber,
			uniqueMemberID,
			memberApprovestatus,
			limit,
			branchID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			MemberID: userAccessMemberID,
			searchValueSet: searchValueSet,
			phoneNumber: phoneNumber,
			aadharNumber: aadharNumber,
			uniqueMemberID: uniqueMemberID,
			memberApprovestatus: memberApprovestatus,
			Limit: limit,
			BranchID: branchID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberDetailsFailure(responseData.data));
		} else {
			yield put(getMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberDetailsFailure(error));
	}
}

export function* resetGetMemberListResponse() {
	yield put(getMemberDetailsResponseChanged());
}

export function* onGetMemberListDetails() {
	yield takeLatest(MemberActionTypes.GET_MEMBER_LIST_START, getMemberList);
}

export function* onGetMemberListResponseReset() {
	yield takeLatest(MemberActionTypes.GET_MEMBER_LIST_RESPONSE_RESET, resetGetMemberListResponse);
}
/** *********************  END GET MEMBER LIST ******************** */

/** *********************  START FETCH MEMBER DETAILS  ******************** */
export function* fetchMemberDetails({ payload }: any) {
	try {
		const key = 'FetchMemberDetailsKey';

		const { companyID, memberID, databaseName, userRoleID } = payload;

		const jsonData = {
			CompanyID: companyID,
			memberID: memberID,
			DatabaseName: databaseName,
			LoginUserRoleID: userRoleID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberDetailsFailure(responseData.data));
		} else {
			yield put(fetchMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberDetailsFailure(error));
	}
}

export function* resetFetchMemberDetailsResponse() {
	yield put(fetchMemberDetailsResponseChanged());
}

export function* onFetchMemberDetails() {
	yield takeLatest(MemberActionTypes.FETCH_MEMBER_DETAILS_START, fetchMemberDetails);
}

export function* onFetchMemberDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.FETCH_MEMBER_DETAILS_RESPONSE_RESET,
		resetFetchMemberDetailsResponse,
	);
}
/** *********************  END FETCH MEMBER DETAILS ******************** */

/** *********************  START DELETE MEMBER DETAILS  ******************** */
export function* deleteMember({ payload }: any) {
	try {
		const key = 'DeleteMemberDetailsKey';

		const { companyID, memberID, databaseName, userID, userAccessMemberID, userName } = payload;

		const jsonData = {
			CompanyID: companyID,
			AreaID: memberID,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessMemberID: userAccessMemberID,
			UserName: userName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteMemberDetailsFailure(responseData.data));
		} else {
			yield put(deleteMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteMemberDetailsFailure(error));
	}
}

export function* resetDeleteMemberDetailsResponse() {
	yield put(deleteMemberDetailsResponseChanged());
}

export function* onDeleteMemberDetails() {
	yield takeLatest(MemberActionTypes.DELETE_MEMBER_DETAILS_START, deleteMember);
}

export function* onDeleteMemberDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.DELETE_MEMBER_DETAILS_RESPONSE_RESET,
		resetDeleteMemberDetailsResponse,
	);
}
/** *********************  END DELETE MEMBER DETAILS ******************** */

/** *********************  START FETCH CO APPLICANT DETAILS  ******************** */
export function* fetchCoApplicantHighMarkDetails({ payload }: any) {
	try {
		const key = 'FetchCoApplicantHighMarkDetailsKey';

		const { companyID, coApplicantID, databaseName } = payload;

		const jsonData = {
			CompanyID: companyID,
			coApplicantID: coApplicantID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(coApplicantHighMarkDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCoApplicantHighMarkDetailsFailure(responseData.data));
		} else {
			yield put(fetchCoApplicantHighMarkDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCoApplicantHighMarkDetailsFailure(error));
	}
}

export function* resetFetchCoApplicantHighMarkDetailsResponse() {
	yield put(fetchCoApplicantHighMarkDetailsResponseChanged());
}

export function* onFetchCoApplicantHighMarkDetails() {
	yield takeLatest(
		MemberActionTypes.FETCH_COAPPLICANT_HIGHMARK_DETAILS_START,
		fetchCoApplicantHighMarkDetails,
	);
}

export function* onFetchCoApplicantHighMarkDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.FETCH_COAPPLICANT_HIGHMARK_DETAILS_RESPONSE_RESET,
		resetFetchCoApplicantHighMarkDetailsResponse,
	);
}
/** *********************  END FETCH CO APPLICANT DETAILS ******************** */

/** *********************  START VERIFY DOCUMENT DETAILS  ******************** */
export function* verifyDocumentDetails({ payload }: any) {
	try {
		const key = 'WebVerifyKYCKey';

		const {
			companyID,
			coApplicantID,
			databaseName,
			documentType,
			memberID,
			documentNumber,
			Type,
			generalCompanyID,
			userID,
			DOB,
			randNumForOTPVerification,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			CoApplicantID: coApplicantID,
			DatabaseName: databaseName,
			documentType: documentType,
			MemberID: memberID,
			MemberCredential: documentNumber,
			Type: Type,
			GeneralCompanyID: generalCompanyID,
			UserID: userID,
			DOB: DOB,
			randNum: randNumForOTPVerification,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			verifyDocumentDetailsFetch,
			encodeData,
			jsonData.documentType,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(verifyDocumentDetailsFailure(responseData.data));
		} else {
			yield put(verifyDocumentDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(verifyDocumentDetailsFailure(error));
	}
}

export function* resetVerifyDocumentDetailsResponse() {
	yield put(verifyDocumentDetailsResponseChanged());
}

export function* onVerifyDocumentDetails() {
	yield takeLatest(MemberActionTypes.VERIFY_DOCUMENT_DETAILS_START, verifyDocumentDetails);
}

export function* onVerifyDocumentDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.VERIFY_DOCUMENT_DETAILS_RESPONSE_RESET,
		resetVerifyDocumentDetailsResponse,
	);
}
/** *********************  END VERIFY DOCUMENT DETAILS ******************** */
/** *********************  START CHECK HIGHMARK DETAILS  ******************** */
export function* checkHighmarkDetails({ payload }: any) {
	try {
		const key = 'CallHighMarkDetailsKey';

		const {
			companyID,
			appliedAmountForHighmark,
			databaseName,
			memberID,
			isConsumer,
			userID,
			generalCompanyID,
			documentType,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			AppliedAmount: appliedAmountForHighmark,
			DatabaseName: databaseName,
			MemberID: memberID,
			IsConsumer: isConsumer,
			UserID: userID,
			GeneralCompanyID: generalCompanyID,
			documentType: documentType,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			checkHighmarkDetailsFetch,
			encodeData,
			jsonData.documentType,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkHighmarkDetailsFailure(responseData.data));
		} else {
			yield put(checkHighmarkDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkHighmarkDetailsFailure(error));
	}
}

export function* resetCheckHighmarkDetailsResponse() {
	yield put(checkHighmarkDetailsResponseChanged());
}

export function* onCheckHighmarkDetails() {
	yield takeLatest(MemberActionTypes.CHECK_HIGHMARK_DETAILS_START, checkHighmarkDetails);
}

export function* onCheckHighmarkDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.CHECK_HIGHMARK_DETAILS_RESPONSE_RESET,
		resetCheckHighmarkDetailsResponse,
	);
}
/** *********************  END VERIFY DOCUMENT DETAILS ******************** */

/** *********************  START CHECK EQUIFAX DETAILS  ******************** */
export function* checkEquifaxDetails({ payload }: any) {
	try {
		const key = 'CallEquifaxDetailsKey';

		const {
			companyID,
			appliedAmountForEquifax,
			databaseName,
			memberID,
			Product,
			isConsumer,
			documentType,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			AppliedAmount: appliedAmountForEquifax,
			DatabaseName: databaseName,
			MemberID: memberID,
			ProductCode: Product,
			IsConsumer: isConsumer,
			documentType: documentType,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			checkEquifaxDetailsFetch,
			encodeData,
			jsonData.documentType,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkEquifaxDetailsFailure(responseData.data));
		} else {
			yield put(checkEquifaxDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkEquifaxDetailsFailure(error));
	}
}

export function* resetCheckEquifaxDetailsResponse() {
	yield put(checkEquifaxDetailsResponseChanged());
}

export function* onCheckEquifaxDetails() {
	yield takeLatest(MemberActionTypes.CHECK_EQUIFAX_DETAILS_START, checkEquifaxDetails);
}

export function* onCheckEquifaxDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.CHECK_EQUIFAX_DETAILS_RESPONSE_RESET,
		resetCheckEquifaxDetailsResponse,
	);
}
/** *********************  END CHECK EQUIFAX DETAILS ******************** */

/** *********************  START CO APPLICANT CHECK HIGHMARK DETAILS  ******************** */
export function* checkCoApplicantHighmarkDetails({ payload }: any) {
	try {
		const key = 'CoBorrowerCrifCheckKey';

		const { companyID, coApplicantID, databaseName, memberID, isConsumer, appliedAmount } =
			payload;

		const jsonData = {
			CompanyID: companyID,
			coApplicantID: coApplicantID,
			DatabaseName: databaseName,
			memberID: memberID,
			IsConsumer: isConsumer,
			AppliedAmount: appliedAmount,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkCoApplicantHighmarkDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkCoApplicantHighmarkDetailsFailure(responseData.data));
		} else {
			yield put(checkCoApplicantHighmarkDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkCoApplicantHighmarkDetailsFailure(error));
	}
}

export function* resetCheckCoApplicantHighmarkDetailsResponse() {
	yield put(checkCoApplicantHighmarkDetailsResponseChanged());
}

export function* onCheckCoApplicantHighmarkDetails() {
	yield takeLatest(
		MemberActionTypes.CHECK_COAPPLICANT_HIGHMARK_DETAILS_START,
		checkCoApplicantHighmarkDetails,
	);
}

export function* onCheckCoApplicantHighmarkDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.CHECK_COAPPLICANT_HIGHMARK_DETAILS_RESPONSE_RESET,
		resetCheckCoApplicantHighmarkDetailsResponse,
	);
}
/** *********************  END VERIFY DOCUMENT DETAILS ******************** */

/** *********************  START UPDATE NO LOAN MEMBER DETAILS  ******************** */
export function* updateNoLoanMemberDetails({ payload }: any) {
	try {
		const key = 'updateNoLoanMemberKey';

		const {
			companyID,
			isNoLoanMember,
			isTopUpLoanNeeded,
			serviceName,
			databaseName,
			memberID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			isNoLoanMember: isNoLoanMember,
			isTopUpLoanNeeded: isTopUpLoanNeeded,
			serviceName: serviceName,
			DatabaseName: databaseName,
			MemberID: memberID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateNoLoanMember, encodeData, jsonData.serviceName);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateNoLoanMemberFailure(responseData.data));
		} else {
			yield put(updateNoLoanMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateNoLoanMemberFailure(error));
	}
}

export function* resetUpdateNoLoanMemberResponse() {
	yield put(updateNoLoanMemberResponseChanged());
}

export function* onUpdateNoLoanMember() {
	yield takeLatest(MemberActionTypes.UPDATE_NO_LOAN_MEMBER_START, updateNoLoanMemberDetails);
}

export function* onupdateNoLoanMemberDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.UPDATE_NO_LOAN_MEMBER_RESPONSE_RESET,
		resetUpdateNoLoanMemberResponse,
	);
}
/** *********************  END NO LOAN MEMBER DETAILS ******************** */

/** *********************  START CHECK TOPUP LOAN MEMBER DETAILS  ******************** */
export function* checkTopupLoanMemberDetails({ payload }: any) {
	try {
		const key = 'CallMemberTopupKey';

		const { companyID, databaseName, memberID } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkTopupLoanMember, encodeData, jsonData.serviceName);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkTopupLoanMemberFailure(responseData.data));
		} else {
			yield put(checkTopupLoanMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkTopupLoanMemberFailure(error));
	}
}

export function* resetCheckTopupLoanMemberResponse() {
	yield put(checkTopupLoanMemberResponseChanged());
}

export function* onCheckTopupLoanMember() {
	yield takeLatest(MemberActionTypes.CHECK_TOPUP_LOAN_MEMBER_START, checkTopupLoanMemberDetails);
}

export function* onCheckTopupLoanMemberDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.CHECK_TOPUP_LOAN_MEMBER_RESPONSE_RESET,
		resetCheckTopupLoanMemberResponse,
	);
}
/** *********************  END NO LOAN MEMBER DETAILS ******************** */

/** *********************  START UPDATE REJECT MEMBER DETAILS  ******************** */
export function* updateMemberDetailsReject({ payload }: any) {
	try {
		const key = 'updateMemberIsApproveKey';

		const {
			companyID,
			userName,
			memberName,
			userID,
			isMemberApproveNotes,
			databaseName,
			memberID,
			IsMemberApproved,
			IsAppraisalApproveNeeded,
			AppraisalApproveID,
			AppraisalApproveSetupID,
			AppraisalLevel,
			isAllApproved,
			NoOfAppraisalApproval,
			isNoLoanMember,
			userLevel,
			isWorkFlowManagementNeeded,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			userName: userName,
			memberName: memberName,
			userID: userID,
			Notes: isMemberApproveNotes,
			DatabaseName: databaseName,
			MemberID: memberID,
			IsMemberApproved: IsMemberApproved,
			IsAppraisalApproveNeeded: IsAppraisalApproveNeeded,
			AppraisalApproveID: AppraisalApproveID,
			AppraisalApproveSetupID: AppraisalApproveSetupID,
			AppraisalLevel: AppraisalLevel,
			isAllAppraisalApproved: isAllApproved,
			NoOfAppraisalApproval: NoOfAppraisalApproval,
			isNoLoanMember: isNoLoanMember,
			Level: userLevel,
			IsWorkflowManagement: isWorkFlowManagementNeeded,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateMemberIsApproveService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberRejectFailure(responseData.data));
		} else {
			yield put(updateMemberRejectSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberRejectFailure(error));
	}
}

export function* resetUpdateMemberRejectResponse() {
	yield put(updateMemberRejectResponseChanged());
}

export function* onUpdateMemberReject() {
	yield takeLatest(MemberActionTypes.REJECT_MEMBER_START, updateMemberDetailsReject);
}

export function* onupdateMemberRejectDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.REJECT_MEMBER_RESPONSE_RESET,
		resetUpdateMemberRejectResponse,
	);
}
/** *********************  END REJECT MEMBER DETAILS ******************** */

/** *********************  START UPDATE RECHECK MEMBER DETAILS  ******************** */
export function* updateMemberDetailsRecheck({ payload }: any) {
	try {
		const key = 'updateMemberIsApproveKey';
		// Destructure fields needed from payload
		const {
			companyID,
			userName,
			memberName,
			userID,
			isMemberApproveNotes,
			databaseName,
			memberID,
			IsMemberApproved,
			IsAppraisalApproveNeeded,
			AppraisalApproveID,
			AppraisalApproveSetupID,
			AppraisalLevel,
			isAllApproved,
			NoOfAppraisalApproval,
			isNoLoanMember,
			userLevel,
			isWorkFlowManagementNeeded,
		} = payload;

		// Build the jsonData object using those variables
		const jsonData = {
			CompanyID: companyID,
			userName: userName,
			memberName: memberName,
			userID: userID,
			Notes: isMemberApproveNotes,
			DatabaseName: databaseName,
			MemberID: memberID,
			IsMemberApproved: IsMemberApproved,
			IsAppraisalApproveNeeded: IsAppraisalApproveNeeded,
			AppraisalApproveID: AppraisalApproveID,
			AppraisalApproveSetupID: AppraisalApproveSetupID,
			AppraisalLevel: AppraisalLevel,
			isAllAppraisalApproved: isAllApproved,
			NoOfAppraisalApproval: NoOfAppraisalApproval,
			isNoLoanMember: isNoLoanMember,
			Level: userLevel,
			IsWorkflowManagement: isWorkFlowManagementNeeded,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateMemberIsApproveService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberRecheckFailure(responseData.data));
		} else {
			yield put(updateMemberRecheckSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberRecheckFailure(error));
	}
}

export function* resetUpdateMemberRecheckResponse() {
	yield put(updateMemberRecheckResponseChanged());
}

export function* onUpdateMemberRecheck() {
	yield takeLatest(MemberActionTypes.RECHECK_MEMBER_START, updateMemberDetailsRecheck);
}

export function* onupdateMemberRecheckDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.RECHECK_MEMBER_RESPONSE_RESET,
		resetUpdateMemberRecheckResponse,
	);
}
/** *********************  END RECHECK MEMBER DETAILS ******************** */

/** *********************  START UPDATE APPROVE MEMBER DETAILS  ******************** */
export function* updateMemberDetailsApprove({ payload }: any) {
	try {
		const key = 'updateMemberIsApproveKey';

		const {
			companyID,
			userName,
			memberName,
			userID,
			isMemberApproveNotes,
			databaseName,
			memberID,
			IsMemberApproved,
			IsAppraisalApproveNeeded,
			AppraisalApproveID,
			AppraisalApproveSetupID,
			AppraisalLevel,
			isAllApproved,
			NoOfAppraisalApproval,
			isNoLoanMember,
			userLevel,
			isWorkFlowManagementNeeded,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			userName: userName,
			memberName: memberName,
			userID: userID,
			Notes: isMemberApproveNotes,
			DatabaseName: databaseName,
			MemberID: memberID,
			IsMemberApproved: IsMemberApproved,
			IsAppraisalApproveNeeded: IsAppraisalApproveNeeded,
			AppraisalApproveID: AppraisalApproveID,
			AppraisalApproveSetupID: AppraisalApproveSetupID,
			AppraisalLevel: AppraisalLevel,
			isAllAppraisalApproved: isAllApproved,
			NoOfAppraisalApproval: NoOfAppraisalApproval,
			isNoLoanMember: isNoLoanMember,
			Level: userLevel,
			IsWorkflowManagement: isWorkFlowManagementNeeded,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateMemberIsApproveService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberApproveFailure(responseData.data));
		} else {
			yield put(updateMemberApproveSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberApproveFailure(error));
	}
}

export function* resetUpdateMemberApproveResponse() {
	yield put(updateMemberApproveResponseChanged());
}

export function* onUpdateMemberApprove() {
	yield takeLatest(MemberActionTypes.APPROVE_MEMBER_START, updateMemberDetailsApprove);
}

export function* onupdateMemberApproveDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.APPROVE_MEMBER_RESPONSE_RESET,
		resetUpdateMemberApproveResponse,
	);
}
/** *********************  END APPROVE MEMBER DETAILS ******************** */

/** *********************  START FETCH PAYSPRINT LOG DETAILS  ******************** */
export function* fetchPaySprintLogDetails({ payload }: any) {
	try {
		const key = 'FetchPaySprintLogDetailsKey';

		const { companyID, memberID, databaseName } = payload;

		const jsonData = {
			CompanyID: companyID,
			MemberID: memberID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(PaySprintLogDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchPaySprintLogDetailsFailure(responseData.data));
		} else {
			yield put(fetchPaySprintLogDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchPaySprintLogDetailsFailure(error));
	}
}

export function* resetFetchPaySprintLogDetailsResponse() {
	yield put(fetchPaySprintLogDetailsResponseChanged());
}

export function* onFetchPaySprintLogDetails() {
	yield takeLatest(MemberActionTypes.FETCH_PAYSPRINT_DETAILS_START, fetchPaySprintLogDetails);
}

export function* onFetchPaySprintLogDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.FETCH_PAYSPRINT_DETAILS_RESPONSE_RESET,
		resetFetchPaySprintLogDetailsResponse,
	);
}
/** *********************  END FETCH PAYSPRINT LOG DETAILS ******************** */

/** *********************  START FETCH MEMBER AUDIT LOG DETAILS  ******************** */
export function* fetchMemberAuditDetails({ payload }: any) {
	try {
		const key = 'MemberAuditFetchApproveKey';

		const { companyID, memberID, databaseName } = payload;

		const jsonData = {
			CompanyID: companyID,
			MemberID: memberID,
			DatabaseName: databaseName,
			AuditType: 'MemberAudit',
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(MemberAuditDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberAuditDetailsFailure(responseData.data));
		} else {
			yield put(fetchMemberAuditDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberAuditDetailsFailure(error));
	}
}

export function* resetFetchMemberAuditDetailsResponse() {
	yield put(fetchMemberAuditDetailsResponseChanged());
}

export function* onFetchMemberAuditDetails() {
	yield takeLatest(MemberActionTypes.FETCH_MEMBER_AUDIT_DETAILS_START, fetchMemberAuditDetails);
}

export function* onFetchMemberAuditDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.FETCH_MEMBER_DETAILS_RESPONSE_RESET,
		resetFetchMemberAuditDetailsResponse,
	);
}
/** *********************  END FETCH AUDIT LOG DETAILS ******************** */

/** *********************  START FETCH MEMBER AUDIT LOG DETAILS  ******************** */
export function* fetchMemberVerifyDetails({ payload }: any) {
	try {
		const key = 'MemberVerifyFetchApproveKey';

		const { companyID, memberID, databaseName } = payload;

		const jsonData = {
			CompanyID: companyID,
			MemberID: memberID,
			DatabaseName: databaseName,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(MemberVerifyDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberVerifyDetailsFailure(responseData.data));
		} else {
			yield put(fetchMemberVerifyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberVerifyDetailsFailure(error));
	}
}

export function* resetFetchMemberVerifyDetailsResponse() {
	yield put(fetchMemberVerifyDetailsResponseChanged());
}

export function* onFetchMemberVerifyDetails() {
	yield takeLatest(MemberActionTypes.FETCH_MEMBER_VERIFY_DETAILS_START, fetchMemberVerifyDetails);
}

export function* onFetchMemberVerifyDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.FETCH_MEMBER_VERIFY_DETAILS_RESPONSE_RESET,
		resetFetchMemberVerifyDetailsResponse,
	);
}
/** *********************  END FETCH AUDIT LOG DETAILS ******************** */

/** *********************  START FETCH MEMBER AUDIT LOG DETAILS  ******************** */
export function* updateMemberVerifyDetails({ payload }: any) {
	try {
		const key = 'MemberVerifyUpdateApproveKey';

		const {
			companyID,
			memberID,
			databaseName,
			isMemberAadharNumberChecked,
			isMemberIDNumberChecked,
			isMemberAddressNumberChecked,
			isMemberPanNumberChecked,
			isMemberNameChecked,
			isMemberDOBChecked,
			isMemberMobileNumberChecked,
			isMemberGenderChecked,
			isMemberAddressChecked,
			isMemberBankChecked,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			MemberID: memberID,
			DatabaseName: databaseName,
			IsAadharVerified: isMemberAadharNumberChecked,
			IsIDProofVerified: isMemberIDNumberChecked,
			IsAddressProofVerified: isMemberAddressNumberChecked,
			IsPanVerified: isMemberPanNumberChecked,
			IsNameVerified: isMemberNameChecked,
			IsDOBVerified: isMemberDOBChecked,
			IsPhoneNumberVerified: isMemberMobileNumberChecked,
			IsGenderVerified: isMemberGenderChecked,
			IsAddressVerified: isMemberAddressChecked,
			IsBankVerified: isMemberBankChecked,
			UserID: userID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(MemberVerifyDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberVerifyDetailsFailure(responseData.data));
		} else {
			yield put(updateMemberVerifyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberVerifyDetailsFailure(error));
	}
}

export function* resetUpdateMemberVerifyDetailsResponse() {
	yield put(updateMemberVerifyDetailsResponseChanged());
}

export function* onUpdateMemberVerifyDetails() {
	yield takeLatest(
		MemberActionTypes.UPDATE_MEMBER_VERIFY_DETAILS_START,
		updateMemberVerifyDetails,
	);
}

export function* onUpdateMemberVerifyDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.UPDATE_MEMBER_VERIFY_DETAILS_RESPONSE_RESET,
		resetUpdateMemberVerifyDetailsResponse,
	);
}

export function* updateMemberKYCDetails({ payload }: any) {
	try {
		const key = 'MemberKYCUpdateKey';

		const {
			MemberID,
			PreviousMemberName,
			MemberName,
			PreviousMemberDateOfJoining,
			MemberDateOfJoining,
			MemberDoorNo,
			MemberAddress,
			MemberPresentDoorNo,
			MemberPresentAddress,
			PreviousMemberCountry,
			MemberCountry,
			PreviousMemberState,
			MemberState,
			PreviousMemberCity,
			MemberCity,
			PreviousMemberContactNo,
			MemberContactNo,
			PreviousMemberAddressProof,
			MemberAddressProof,
			PreviousMemberAddressProofValue,
			MemberAddressProofValue,
			PreviousMemberIDProof,
			MemberIDProof,
			PreviousMemberIDProofValue,
			MemberIDProofValue,
			PreviousMemberAadharCardNo,
			MemberAadharCardNo,
			PreviousMemberPassbookNo,
			MemberPassbookNo,
			PreviousMemberBankName,
			MemberBankName,
			MemberBankBranch,
			MemberUniqueID,
			databaseName,
			userID,
			userName,
			companyID,
		} = payload;

		// Build the jsonData object
		const jsonData = {
			MemberID,
			PreviousMemberName,
			MemberName,
			PreviousMemberDateOfJoining,
			MemberDateOfJoining,
			MemberDoorNo,
			MemberAddress,
			MemberPresentDoorNo,
			MemberPresentAddress,
			PreviousMemberCountry,
			MemberCountry,
			PreviousMemberState,
			MemberState,
			PreviousMemberCity,
			MemberCity,
			PreviousMemberContactNo,
			MemberContactNo,
			PreviousMemberAddressProof,
			MemberAddressProof,
			PreviousMemberAddressProofValue,
			MemberAddressProofValue,
			PreviousMemberIDProof,
			MemberIDProof,
			PreviousMemberIDProofValue,
			MemberIDProofValue,
			PreviousMemberAadharCardNo,
			MemberAadharCardNo,
			PreviousMemberPassbookNo,
			MemberPassbookNo,
			PreviousMemberBankName,
			MemberBankName,
			MemberBankBranch,
			MemberUniqueID,
			DatabaseName: databaseName,
			officerID: userID,
			UserName: userName,
			CompanyID: companyID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(MemberKYCDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberKYCDetailsFailure(responseData.data));
		} else {
			yield put(updateMemberKYCDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberKYCDetailsFailure(error));
	}
}

export function* resetUpdateMemberKYCDetailsResponse() {
	yield put(updateMemberKYCDetailsResponseChanged());
}

export function* onUpdateMemberKYCDetails() {
	yield takeLatest(MemberActionTypes.UPDATE_MEMBER_KYC_DETAILS_START, updateMemberKYCDetails);
}

export function* onUpdateMemberKYCDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.UPDATE_MEMBER_KYC_DETAILS_RESPONSE_RESET,
		resetUpdateMemberKYCDetailsResponse,
	);
}

export function* updateMemberTransferDetails({ payload }: any) {
	try {
		const key = 'MemberTransferUpdateKey';
		const {
			MemberID,
			databaseName,
			userID,
			userName,
			companyID,
			userRole,
			userLevel,
			branchID,
			FromCenterID,
			FromGroupID,
			ToCenterID,
			ToGroupID,
			memberCode,
			PreviousMemberUniqueID,
			TransferMemberUniqueID,
		} = payload;

		const jsonData = {
			MemberID,
			DatabaseName: databaseName,
			UserID: userID,
			UserName: userName,
			CompanyID: companyID,
			UserRole: userRole,
			Level: userLevel,
			BranchID: branchID,
			FromCenterID,
			FromGroupID,
			ToCenterID,
			ToGroupID,
			MemberCode: memberCode,
			PreviousMemberUniqueID,
			TransferMemberUniqueID,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(MemberTransferDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberTransferDetailsFailure(responseData.data));
		} else {
			yield put(updateMemberTransferDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberTransferDetailsFailure(error));
	}
}

export function* resetUpdateMemberTransferDetailsResponse() {
	yield put(updateMemberTransferDetailsResponseChanged());
}

export function* onUpdateMemberTransferDetails() {
	yield takeLatest(
		MemberActionTypes.UPDATE_MEMBER_TRANSFER_DETAILS_START,
		updateMemberTransferDetails,
	);
}

export function* onUpdateMemberTransferDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.UPDATE_MEMBER_TRANSFER_DETAILS_RESPONSE_RESET,
		resetUpdateMemberTransferDetailsResponse,
	);
}
/** *********************  END FETCH AUDIT LOG DETAILS ******************** */

/** *********************  START ADD MEMBER OTHER DETAILS  ******************** */
export function* addMemberOtherDetails({ payload }: any) {
	try {
		const key = 'AddMemberOtherDetailsKey';
		const {
			userID,
			databaseName,
			companyID,
			memberID,
			msmeNumber,
			msmeDocumentImage,
			gstNumber,
			gstDocumentImage,
			financialDocument1,
			financialDocument2,
			financialDocument3,
			incomeProofDocument1,
			incomeProofDocument2,
			incomeProofDocument3,
			itReturnDocument1,
			itReturnDocument2,
			itReturnDocument3
		} = payload;

		const jsonData = {
			CreatedBy: userID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			MemberID: memberID,
			MSMENumber: msmeNumber,
			MSMEDocumentImage: msmeDocumentImage,
			GSTNumber: gstNumber,
			GSTDocumentImage: gstDocumentImage,
			FinancialDocument1: financialDocument1,
			FinancialDocument2: financialDocument2,
			FinancialDocument3: financialDocument3,
			IncomeProofDocument1: incomeProofDocument1,
			IncomeProofDocument2: incomeProofDocument2,
			IncomeProofDocument3: incomeProofDocument3,
			ITReturnDocument1: itReturnDocument1,
			ITReturnDocument2: itReturnDocument2,
			ITReturnDocument3: itReturnDocument3
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberOtherDetailsAdd, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addMemberOtherDetailsFailure(responseData.data));
		} else {
			yield put(addMemberOtherDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addMemberOtherDetailsFailure(error));
	}
}

export function* resetAddMemberOtherDetailsResponse() {
	yield put(addMemberOtherDetailsResponseChanged());
}

export function* onAddMemberOtherDetails() {
	yield takeLatest(MemberActionTypes.ADD_MEMBER_OTHER_DETAILS_START, addMemberOtherDetails);
}

export function* onAddMemberOtherDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.ADD_MEMBER_OTHER_DETAILS_RESPONSE_RESET,
		resetAddMemberOtherDetailsResponse,
	);
}
/** *********************  END ADD MEMBER OTHER DETAILS ******************** */

/** *********************  START ADD MEMBER BUSINESS DETAILS  ******************** */
export function* addMemberBusinessDetails({ payload }: any) {
	try {
		const key = 'AddMemberBusinessDetailsKey';
		const {
			userID,
			databaseName,
			companyID,
			memberID,
			businessName,
			businessType,
			noOfYearsOperation,
			weeklyBill,
			businessData,
		} = payload;

		const jsonData = {
			CreatedBy: userID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			MemberID: memberID,
			BusinessName: businessName,
			BusinessType: businessType,
			NoOfYearsOperation: noOfYearsOperation,
			WeeklyBill: weeklyBill,
			BusinessData: businessData,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberBusinessDetailsAdd, encodeData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addMemberBusinessDetailsFailure(responseData.data));
		} else {
			yield put(addMemberBusinessDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addMemberBusinessDetailsFailure(error));
	}
}

export function* resetAddMemberBusinessDetailsResponse() {
	yield put(addMemberBusinessDetailsResponseChanged());
}

export function* onAddMemberBusinessDetails() {
	yield takeLatest(MemberActionTypes.ADD_MEMBER_BUSINESS_DETAILS_START, addMemberBusinessDetails);
}

export function* onAddMemberBusinessDetailsResponseReset() {
	yield takeLatest(
		MemberActionTypes.ADD_MEMBER_BUSINESS_DETAILS_RESPONSE_RESET,
		resetAddMemberBusinessDetailsResponse,
	);
}
/** *********************  END ADD MEMBER BUSINESS DETAILS ******************** */

/** *********************  END ADD MEMBER OTHER DETAILS ******************** */

export function* memberMasterSaga() {
	yield all([
		call(onAddMemberDetails),
		call(onAddMemberDetailsResponseReset),
		call(onUpdateMemberDetails),
		call(onUpdateMemberResponseReset),
		call(onGetMemberListDetails),
		call(onGetMemberListResponseReset),
		call(onFetchMemberDetails),
		call(onFetchMemberDetailsResponseReset),
		call(onDeleteMemberDetails),
		call(onDeleteMemberDetailsResponseReset),
		call(onFetchCoApplicantHighMarkDetails),
		call(onFetchCoApplicantHighMarkDetailsResponseReset),
		call(onVerifyDocumentDetails),
		call(onVerifyDocumentDetailsResponseReset),
		call(onCheckHighmarkDetails),
		call(onCheckHighmarkDetailsResponseReset),
		call(onCheckEquifaxDetails),
		call(onCheckEquifaxDetailsResponseReset),
		call(onCheckCoApplicantHighmarkDetails),
		call(onCheckCoApplicantHighmarkDetailsResponseReset),
		call(onUpdateNoLoanMember),
		call(onupdateNoLoanMemberDetailsResponseReset),
		call(onCheckTopupLoanMember),
		call(onCheckTopupLoanMemberDetailsResponseReset),
		call(onUpdateMemberReject),
		call(onupdateMemberRejectDetailsResponseReset),
		call(onUpdateMemberRecheck),
		call(onupdateMemberRecheckDetailsResponseReset),
		call(onUpdateMemberApprove),
		call(onupdateMemberApproveDetailsResponseReset),
		call(onFetchPaySprintLogDetails),
		call(onFetchPaySprintLogDetailsResponseReset),
		call(onFetchMemberAuditDetails),
		call(onFetchMemberAuditDetailsResponseReset),
		call(onFetchMemberVerifyDetails),
		call(onFetchMemberVerifyDetailsResponseReset),
		call(onUpdateMemberVerifyDetails),
		call(onUpdateMemberVerifyDetailsResponseReset),
		call(onUpdateMemberKYCDetails),
		call(onUpdateMemberKYCDetailsResponseReset),
		call(onUpdateMemberTransferDetails),
		call(onUpdateMemberTransferDetailsResponseReset),
		call(onAddMemberOtherDetails),
		call(onAddMemberOtherDetailsResponseReset),
		call(onAddMemberBusinessDetails),
		call(onAddMemberBusinessDetailsResponseReset),
	]);
}
